import { useRouter } from 'next/router';
import { slugify } from '@/utils/helpers';
import { ArticleList } from './ArticleList';
import { SelectField } from '@zopauk/web-ui';
import { PillNavigationList } from '@/components/PillNavigationList';

type HubNavigaionProps = {
  collections: {
    title?: undefined | string | null;
    slug?: undefined | string | null;
  }[];
  questions: {
    title?: undefined | string | null;
    slug?: undefined | string | null;
  }[];
  hub: {
    slug?: undefined | string | null;
  };
  title?: string | null;
};

export const HubNavigation = ({ collections, questions, title, hub }: HubNavigaionProps) => {
  const { replace, asPath } = useRouter();

  const menu = [
    { href: `/help/${hub.slug}`, title: 'Top FAQs' },
    ...collections.map(({ title, slug }) => ({
      href: `/help/collection/${slug}`,
      title,
    })),
    { href: `/help/${hub.slug}/all`, title: 'All' },
  ];

  return (
    <>
      <div className="lg:hidden mb-6">
        <SelectField
          onChange={(e) => {
            replace(e.currentTarget.value, undefined, {
              scroll: false,
            });
          }}
          name="collections-navigation"
          className="w-full"
          label="Filter"
          value={asPath}
        >
          {menu.map(({ title, href }) => (
            <option key={slugify(href)} value={href}>
              {title}
            </option>
          ))}
        </SelectField>
      </div>

      <div className="flex xl:px-11">
        <div className="hidden w-2/5 lg:block">
          <PillNavigationList list={menu} />
        </div>

        <div className="lg:pl-8">
          {title ? <h2 className="mb-5 hidden l:block">{title}</h2> : null}

          <ArticleList articles={questions} />
        </div>
      </div>
    </>
  );
};
